import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      padding: 0,
      boxSizing: 'border-box',
      color: theme.value.typography.color,
      fontFamily: theme.value.typography.fontFamily,
    },
    '&__ul': {
      display: 'flex',
      listStyleType: 'none',
      gap: '1.5rem',
    },
    '&__button': {
      backgroundColor: 'transparent',
      border: '0',
      outline: 'none',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      textAlign: 'center',
      '&:hover': {
        cursor: 'pointer',
        fontWeight: theme.value.typography.fontWeight.semibold,
      },
    },
    '&__not-selected': {
      '&:hover': {
        '&:after': {
          content: '""',
          float: 'left',
          background: theme.value.colors.primary.light1,
          width: '100%',
          height: '0.25rem',
          borderRadius: '0.5rem',
        },
      },
    },
    '&__selected': {
      fontWeight: theme.value.typography.fontWeight.semibold,
      '&:after': {
        content: '""',
        float: 'left',
        background: theme.value.colors.primary.main,
        width: '100%',
        height: '0.25rem',
        borderRadius: '0.5rem',
      },
    },
  }));

  return baseClass;
};
